module.controller('changePinCtrl', ['$scope', '$stateParams', '$state', '$http', '$q', 'cacheService', 'Session', 'Transform', 'baseURI', 'accountService', 'OVERLAY',
  function ($scope, $stateParams, $state, $http, $q, cacheService, Session, Transform, baseURI, accountService, OVERLAY){
    var changePin = baseURI + 'card/changepin';
    var subUrl = baseURI + 'card/sub-cards';
    $scope.overlay = OVERLAY['member.home.profile/changepin'];
    $scope.formData = {};
    $scope.hasSubs = Session.getHasSubs();
    $scope.attempted = false;
    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to change your PIN at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
    $scope.primary = {};
    $scope.username = $stateParams.username;
    $scope.cards = accountService.getAccounts();

    $scope.getCurrentAccount = function() {
      if ($scope.cards && $scope.cards.length > 0 && $scope.cards[0].firstName) {
        $scope.primary.firstName = $scope.cards[0].firstName;
        $scope.primary.lastName = $scope.cards[0].lastName;
        for (var i = 0; i < $scope.cards.length; i++) {
          if ($scope.username === $scope.cards[i].username) {
            return i;
          }
        }
      }
    };

    $scope.getCardAccounts = function() {
      if ($scope.cards && $scope.cards.length > 0 && $scope.cards[0].firstName) {
        $scope.primary.firstName = $scope.cards[0].firstName;
        return $scope.cards;
      }
    };

    $scope.getCardUsername = function() {
      if ($scope.$$prevSibling.accounts && $scope.$$prevSibling.accounts.length > 0 && $scope.$$prevSibling.accounts[0].firstName) {
        return $scope.username;
      }
    };

    $scope.attemptSubmission = function (formData){
      if(formData.$valid && !$scope.subPinsMatch()){
        transformPins();
        $scope.alert.errorShown = false;
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };

    $scope.subPinsMatch = function(){
      var misMatch = false;
      for(var s in $scope.subCards){
        if($scope.subCards[s].change == 'on'){
          if($scope.subCards[s].NewPin != $scope.subCards[s].ConfirmPin){
            misMatch = true;
            $scope.subCards[s].misMatch = true;
          } else {
            $scope.subCards[s].misMatch = false;
          }
        }
      }
      return misMatch;
    };


    var transformPins = function(){
      var pinsToChange = [];

      if($scope.formData.change == 'on'){
        var primaryPin = {
          NewPin: $scope.formData.PrimaryPin
        };
        pinsToChange.push(primaryPin);
      }

      for(var sub in $scope.subCards){
        if($scope.subCards[sub].change == 'on'){
          var subPin = {
            NewPin: $scope.subCards[sub].NewPin,
            Username: $scope.subCards[sub].Username
          };
          pinsToChange.push(subPin);
        }
      }

      if(pinsToChange.length > 0){
        changePins(pinsToChange);
      }

    };

    // change CH pins
    // args: Array of Pins
    var changePins = function(pins){

      var promises = pins.map(function(pin, index){

        var deffered = $q.defer();

        $http({
          method: 'POST',
          url: changePin,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          data: Transform.encode(pin)
        }).then(function(resp){
          var data = resp.data;

          deffered.resolve(data);
        }).catch(function(error){
          deffered.resolve(error);
        });

        return deffered.promise;

      });

      $q.all(promises).then(function (dataArray){
        var success = true;
        $scope.loading = false;

        for(var req in dataArray){
          if(!dataArray[req].Success){
            success = false;
            $scope.alert.alertShown = true;
            break;
          }
        }

        if(success){
          // Clear feed notifications
          cacheService.clear('feeds');

          $scope.alert.successMessage = 'You have updated your PIN';
          $scope.alert.successShown = true;
          $state.go('member.home.profile/changepin.confirmation');
        }
      });

    };

    var getSubs = function(){
      $scope.loadingSubs = true;
      $http.get(subUrl, {cache: true}).then(function (resp){
        var subCards = resp.data.Data || [];
        $scope.subCards = subCards;
        $scope.loadingSubs = false;
      }).catch(function (error){
        $scope.loadingSubs = false;
        console.log('err', error);
      });
    };

    if(Session.getHasSubs()){
      getSubs();
    }

  }]);
